import { ComponentType, PropsWithChildren, ReactNode, isValidElement } from 'react';

export type NoProps = Record<string, never>;

export type OnlyChildren = PropsWithChildren<unknown>;

/**
 * Infers the props of a React component type
 */
export type PropsOf<TComponent> = TComponent extends ComponentType<
  React.PropsWithChildren<infer PropsType>
>
  ? PropsType
  : unknown;

/**
 * Converts a given ReactNode to string
 *
 * @param reactNode ReactNode
 * @returns string
 */
export const reactNodeToString = (reactNode: ReactNode) => {
  let string = '';
  switch (typeof reactNode) {
    case 'string':
      return reactNode;

    case 'number':
    case 'boolean':
      return reactNode.toString();

    default:
  }

  if (reactNode instanceof Array) {
    reactNode.forEach((child) => {
      string += reactNodeToString(child);
    });
  } else if (isValidElement(reactNode)) {
    string += reactNodeToString(reactNode.props.children);
  }

  return string;
};

/**
 * A utility component that renders nothing.
 */
export const NoOpComponent = () => null;
